import {publicClient} from 'common/util/public-client';
import {FetchOptions} from 'common/util/shared-client';
import {DataGroup} from 'common/widgets/data-group-selector/types';
import {EventDefinition, PropertyDefinition} from 'common/report/queries/app-api/data-definitions-types';
import {Dashboard} from 'common/report/dashboards/types';

import {appApiUrl} from '../utils';

/* Public Dashboards are app_api/public/views.py. Should only be used within unauthenticated context (e.g. Dashboard App in Public Mode)*/
class PublicDashClient {
  /** Sends a HTTP GET request to retrieve a specific dashboard */
  querySingle({dashboardID}: {dashboardID: string}, options: FetchOptions & {clearCache: boolean}) {
    if (options.clearCache && !Object.prototype.hasOwnProperty.call(options, `fromFetchCache`)) {
      options.fromFetchCache = false;
    }

    return publicClient.get<Dashboard>(appApiUrl(`public/dashboards/${dashboardID}/`), null, {
      throwOnInvalidStatus: true,
      ...options,
    });
  }

  verifyPasscode(dashboardId: string, passcode: string) {
    return publicClient.post<Dashboard>(
      appApiUrl(`public/verify/${dashboardId}/`),
      {password: passcode},
      {throwOnInvalidStatus: true},
    );
  }

  // eslint-disable-next-line @typescript-eslint/naming-convention
  queryCard({uuid, bookmarkId, cardId, endpoint, client_version, time_comparison}) {
    return publicClient.post(appApiUrl(`public/dashboard-cards`), {
      uuid,
      bookmark_id: bookmarkId,
      card_id: cardId,
      // TODO: endpoint should be calculated server-side, can't trust user on either
      endpoint,
      // time comparison needed for metrics cards to compare diff
      ...(time_comparison ? {time_comparison} : {}),
      ...(client_version ? {client_version} : {}),
    });
  }

  getMetadata(dashboardId: string, options: FetchOptions & {clearCache: boolean}) {
    if (options.clearCache && !Object.prototype.hasOwnProperty.call(options, `fromFetchCache`)) {
      options.fromFetchCache = false;
    }

    return publicClient.get<{
      is_free_plan: boolean;
      project_timezone: string;
      utc_offset: number;
      data_groups: Record<string, DataGroup>;
      event_definitions?: EventDefinition[];
      event_properties?: PropertyDefinition[];
      people_properties?: PropertyDefinition[];
      org_id: number;
      project_as_of_date: string | null;
    }>(appApiUrl(`public/dashboards/${dashboardId}/metadata`), null, {
      throwOnInvalidStatus: true,
      ...options,
    });
  }
}

export type PublicDashboardsClient = InstanceType<typeof PublicDashClient>;
export const publicDashboardsClient = new PublicDashClient();
